export enum EventType {
  firewall = 2,
  controllers = 1,
  lockdown = 5,
  system = 4,
  alert = 3,
  camera = 0,
  fingerprint = 6
}
